// extracted by mini-css-extract-plugin
export var box = "_44-1";
export var checkboxRow = "_44-8";
export var checked = "_44-2";
export var descriptionSpacer = "_44-a";
export var disabled = "_44-3";
export var icon = "_44-6";
export var input = "_44-0";
export var labelSpacer = "_44-9";
export var medium = "_44-5";
export var small = "_44-4";
export var text = "_44-7";